<template>
  <div class="po-r w100 pt20 pb20 pl20 pr20 bg-w" v-loading="loading">
    <p class="w100 font-16">角色与部门关系设置</p>
    <div class="w100 pb20 cl-f">
      <div class="fr">
        搜索关键字：
        <el-input class="mr20" style="width: 200px;" v-model="searchText" @keyup.enter.native="fetchList" placeholder="可输入关键字查询"></el-input>
        <el-button type="primary" @click="page = 1, fetchList()">查询</el-button>
        <el-button type="warning" :loading="loading" @click="showAddView">新增</el-button>
        <el-button @click="delRole">删除</el-button>
      </div>
    </div>

    <el-table class="w100" :data="list" stripe border height="550" @selection-change="changeListSelect">
      <el-table-column align="center" type="selection" width="55"></el-table-column>
      <el-table-column align="center" label="序号" width="60">
        <template slot-scope="scope">
          <span>{{ ((page - 1) * size) + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="部门名称" prop="departmentName"></el-table-column>
      <el-table-column align="center" label="角色名称" prop="roleName"></el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createDate | filterDate('yyyy-MM-dd') }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing" width="1000px">
      <span class="font-16" slot="title">新增关系链</span>
      <div class="w100">
        <div class="w100 pb20 cl-f">
          <div class="fr">
            <el-input class="mr20" style="width: 200px;" v-model="searchTextNew" @keyup.enter.native="fetchListNew" placeholder="可输入关键字查询"></el-input>
            <el-button type="primary" @click="fetchListNew" :loading="searching || updataing">查询</el-button>
          </div>
        </div>
        <el-table class="w100 tx-c my-table" :data="listNew" stripe border height="550" @selection-change="changeListSelecNew">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" label="部门名称" prop="departmentName"></el-table-column>
          <el-table-column align="center" label="角色名称" prop="roleName"></el-table-column>
        </el-table>

        <div class="w100 mt20 tx-r">
          <el-pagination @size-change="changeSizeNew" @current-change="changePageNew" :current-page="pageNew" :page-sizes="[30, 50, 100]" :page-size="sizeNew" layout="total, sizes, prev, pager, next, jumper" background :total="totalNew"></el-pagination>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="primary" :loading="updataing" @click="addNewData">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeRoleForDepartment",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      searchText: "",
      list: [],
      page: 1,
      size: 30,
      total: 0,
      listSelect: [],

      isShow: false,
      updataing: false,
      searching: false,
      searchTextNew: "",
      listNew: [],
      pageNew: 1,
      sizeNew: 30,
      totalNew: 0,
      listSelectNew: []
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;

      this.$http
        .post(
          "deptRole/query",
          this.$qs.stringify({
            queryKey: this.searchText,
            pageNum: this.page,
            pageSize: this.size
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    fetchListNew() {
      this.searching = true;

      this.$http
        .post(
          "deptRole/getAddList",
          this.$qs.stringify({
            queryKey: this.searchTextNew,
            pageNum: this.pageNew,
            pageSize: this.sizeNew
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.listNew = data.resData.list;
            this.totalNew = data.resData.total;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.searching = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.searching = false;
        });
    },
    addNewData() {
      if (!this.listSelectNew.length) {
        this.$message({
          message: `请至少选择一条数据提交`,
          type: "error"
        });
        return;
      }
      const obj = this.listSelectNew.map(val => {
        return {
          roleId: val.roleId,
          departmentId: val.departmentId
        };
      });

      this.updataing = true;
      this.$http
        .post("deptRole/add", JSON.stringify(obj), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.$message({
              message: data.resMsg,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.isShow = false;
          this.updataing = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.isShow = false;
          this.updataing = false;
        });
    },
    delRole() {
      if (!this.listSelect.length) {
        this.$message({
          message: `请至少选择一条数据提交`,
          type: "error"
        });
        return;
      }

      this.$confirm("是否移除选中项", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const obj = this.listSelect.map(val => val.id);

          this.loading = true;
          this.$http
            .post("deptRole/delete", JSON.stringify(obj), {
              headers: {
                "Content-Type": "application/json;charset=utf-8"
              }
            })
            .then(({ data }) => {
              // console.log(data);
              if (data.resStatus == 0 && data.resCode == 0) {
                this.$message({
                  message: data.resMsg,
                  type: "success"
                });
                this.fetchList();
              } else {
                this.$message({
                  message: data.resMsg,
                  type: "error"
                });
              }
              this.loading = true;
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.loading = true;
            });
        })
        .catch(() => {});
    },
    showAddView() {
      this.totalNew = 0;
      this.pageNew = 1;
      this.searchTextNew = "";
      this.isShow = true;
      this.fetchListNew();
    },
    changeListSelect(value) {
      this.listSelect = value;
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    changeListSelecNew(value) {
      this.listSelectNew = value;
    },
    changeSizeNew(value) {
      this.sizeNew = value;
      this.fetchListNew();
    },
    changePageNew(value) {
      this.pageNew = value;
      this.fetchListNew();
    }
  },
  watch: {}
};
</script>

<style scoped>
</style>
